<ng-container *ngIf="!column.editable">
  @switch (column.format) {
  @case ('Datetime') {
  <p [style]="column.style">
    {{ row[column.columnDef] ? (row[column.columnDef] | date: 'dd/MM/yyyy HH:mm') : '-' }}
  </p>
  }

  @case ('MinuteToHour') {
  <p [style]="column.style">
    {{ transformService.convertMinutesToTimeString( row[column.columnDef] ) }}
  </p>
  }

  @case ('Date') {
  <p [style]="column.style">
    {{ row[column.columnDef] | date: 'dd/MM/yyyy' }}
  </p>
  }

  @case ('SimNao') {
  <p [style]="column.style">
    {{ row[column.columnDef] ? "Sim" : "Não" }}
  </p>
  }

  @case ('Currency') {
  <div class="currency">
    <p currencyMask class="currency">
      {{ row[column.columnDef] ?? 0 | currency }}
    </p>
  </div>
  }

  @case ('Function') {
  <p truncateText [maxLength]="column.maxChars + 5" [more]="'Mais'" [less]="'Esconder'" [style]="column.style">
    {{ column.function(row) }}
  </p>
  }

  @case ('Image') {
  <ng-container>
    <img *ngIf="row[column.columnDef]" [src]="'data:image/jpeg;base64,' + row[column.columnDef]" class="image-column" />
  </ng-container>
  }

  @default {
  <ng-container>
    <p *ngIf="!column.routerLink && !column.link" truncateText [maxLength]="column.maxChars + 5" [more]="'Mais'"
      [less]="'Esconder'" [style]="column.style">
      {{ row[column.columnDef] }}
    </p>

    <a mat-button *ngIf="column.routerLink" truncateText [maxLength]="column.maxChars + 5" [more]="'Mais'"
      [less]="'Esconder'" [style]="column.style" class="link-interno"
      [routerLink]="resolveRouterLink(row)" [queryParams]="column.queryParams" [attr.target]="column.target">
      {{ row[column.columnDef] }}
    </a>

    <a mat-button *ngIf="column.link && row[column.columnDef]" truncateText [maxLength]="column.maxChars + 5"
      [more]="'Mais'" [less]="'Esconder'" [style]="column.style" class="link-interno"
      [href]="column.link.replace('\{\{queryParams\}\}', row[column.columnDef])" [target]="column.target">
      {{ row[column.columnDef] }}
    </a>
  </ng-container>
  }
  }
</ng-container>

<ng-container *ngIf="column.editable">
  @switch (column.format) {

  @case ('ComboBox') {
  <mat-form-field class="combo-box-field">
    <mat-select [(ngModel)]="row[column.columnDef]" [style]="column.style" [aria-label]="column.header">
      @for (option of column.options; track option.value) {
      <mat-option [value]="option.value">{{ option.key }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }

  @case ('SlideToggle') {
  <mat-slide-toggle [(ngModel)]="row[column.columnDef]" [name]="column.columnDef" color="primary" [style]="column.style"
    (change)="column?.onChange($event, row)">
  </mat-slide-toggle>
  }

  @case ('CheckBox') {
  <mat-checkbox [checked]="row[column.columnDef]" [(ngModel)]="row[column.columnDef]"></mat-checkbox>
  }

  @case ('Date') {
  <mat-form-field fxFlex>
    <input matInput type="date" max="9999-12-31" autocomplete="off" [readonly]="column.readonly" [(ngModel)]="row[column.columnDef]"
      (blur)="column?.onBlur(row)" />
  </mat-form-field>
  }

  @case ('Currency') {
  <mat-form-field fxFlex>
    <input matInput currencyMask [options]="{ precision: column.decimals, allowNegative: true }" type="text" [readonly]="column.readonly"
      autocomplete="off" [(ngModel)]="row[column.columnDef]" (blur)="column?.onBlur(row)"
      (ngModelChange)="column?.onChange($event, row)" />
  </mat-form-field>
  }

  @case ('Number') {
  <mat-form-field fxFlex>
    <input matInput [(ngModel)]="row[column.columnDef]" [style]="column.style" [readonly]="column.readonly" (blur)="column?.onBlur(row)"
      type="number" (change)="column?.onChange($event, row)" />
  </mat-form-field>
  }

  @default {
  <mat-form-field fxFlex>
    <input matInput [(ngModel)]="row[column.columnDef]" [style]="column.style" (blur)="column?.onBlur(row)"
      (change)="column?.onChange($event, row)" [readonly]="column.readonly" />
  </mat-form-field>
  }

  }
</ng-container>
